module.exports = __webpack_public_path__ + "static/media/2.5_preview.2b374ce4.png";